import { upperFirst, camelCase } from 'lodash';

var styles = {"alignLeft":"OP0IV","textWrapNowrap":"TyeK4","alignRight":"ShlAQ","alignCenter":"Kx0Lf","sizeFullWidth":"_1-q7Q","renderedInTable":"EcxrX","sizeOriginal":"_27wo6","sizeContent":"fbfkF","sizeSmall":"vqDZj","sizeSmallCenter":"hkk15","flex":"a4qsQ","atomic":"Zwy3F","anchor":"-CNZO","embed":"dTCr6","horizontalScrollbar":"Uxi-P","pluginContainerMobile":"_71bL4"};

const getContainerData = (node) => {
  var _a;
  const data = `${camelCase(node.type)}Data`;
  return (_a = node == null ? void 0 : node[data]) == null ? void 0 : _a.containerData;
};
const getAlignmentClassName = (containerData = {}) => {
  const { alignment } = containerData;
  if (!alignment) {
    return "";
  }
  const key = `align${upperFirst(alignment.toLowerCase())}`;
  return styles[key];
};
const getSizeClassName = (containerData) => {
  const { width } = containerData;
  const { size } = width || {};
  if (!size) {
    return "";
  }
  const key = `size${upperFirst(camelCase(size.toLowerCase()))}`;
  return styles[key];
};
const getTextWrapClassName = (containerData = {}) => {
  const { textWrap } = containerData;
  if (textWrap) {
    return "";
  }
  return styles.textWrapNowrap;
};
const alignmentClassName = (node) => {
  return getAlignmentClassName(getContainerData(node));
};
const sizeClassName = (node) => {
  return getSizeClassName(getContainerData(node) || {});
};
const textWrapClassName = (node) => {
  return getTextWrapClassName(getContainerData(node));
};

export { getSizeClassName as a, getTextWrapClassName as b, alignmentClassName as c, sizeClassName as d, getAlignmentClassName as g, styles as s, textWrapClassName as t };
//# sourceMappingURL=getClassNames-6123816f.js.map
